'use client'

import { useEffect } from 'react'

import { getGtmBootDiagnostics } from '@/lib/site/gtm-config'

/**
 * Logs a one-liner GTM boot summary to the browser console exactly once
 * per page load. Active in non-production builds only — production users
 * never see it.
 *
 * Useful to confirm at a glance which container ID a preview / staging
 * deploy is pointing at and whether `NEXT_PUBLIC_GTM_DEBUG=1` is in play.
 */
export function GtmBootDiagnostics() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return
    }
    console.info(getGtmBootDiagnostics())
  }, [])

  return null
}
